export default "__VITE_ASSET__BwW_U5gg__"